import types from '../types';
import { duckConstants } from '../../../constants';
import { extractState } from '../../../utilities/combineUseReducer';

const reducer = (state, action) => {
  switch (action.type) {
    case types.REQUESTING: {
      return { ...state, requesting: action.requesting };
    }

    case types.CLEAR_SUCCESS_ERROR_FLAGS:
    case types.RESET_DATA: {
      return { ...state, checkMessage: null, addTrackChallengeMessage: null, requesting: null };
    }

    case types.CHECK_LCI_CODE: {
      return { ...state, join_access_code: action.join_access_code };
    }

    case types.CHECK_LCI_CODE_SUCCESS: {
      return { ...state, checkMessage: { type: 'success' }, lciList: action.result };
    }

    case types.CHECK_LCI_CODE_ERROR: {
      return { ...state, checkMessage: { type: 'error' }, lciList: null };
    }

    case types.SET_JOIN_LCI_INFO: {
      return { ...state, ...action };
    }

    case types.BY_PASS_AUTO_JOIN_IF_BACK: {
      return { ...state, by_pass_auto_join_if_back: true };
    }

    case types.CLEAR_AUTO_JOIN_IF_BACK: {
      delete state.by_pass_auto_join_if_back;
      return { ...state };
    }

    case types.ADD_TRACK_CHALLENGE: {
      return state;
    }

    case types.ADD_TRACK_CHALLENGE_SUCCESS: {
      /* OUR SPECIAL VALUES, SHOULD RE-FACTOR TO USE THE SAME ROOT KEY */
      const { k, v } = action;
      localStorage.setItem('k', k);
      localStorage.setItem('v', v);
      localStorage.removeItem('chromeTypeFix');
      /*****************************************************************/
      return { ...state, addTrackChallengeMessage: { type: 'success' } };
    }

    case types.ADD_TRACK_CHALLENGE_ERROR: {
      return { ...state, addTrackChallengeMessage: { type: 'error' } };
    }

    case types.REHYDRATE: {
      /* INITIAL STATE */
      const initialState = (state && state[stateKey]) ? { ...state[stateKey] } : extractState(duckConstants.LCI_LIVE_CODE, stateKey);
      return { ...state, ...initialState };
    }

    default:
      return state;
  }
};

const stateKey = 'lciIntro';

export default { reducer, stateKey };
